module.exports = __webpack_public_path__ + "static/akinsanya-1beb1d6ce537fac5c928052a580d2b0d.png";